//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import Loader from "./Loader";

export default {
  name: "LoadMore",
	props: {
		navigate: Function,
		enableNext: Boolean,
		loaded: Boolean,
	},
	components: {
		Loader
	},
	computed: {
		...mapGetters([
			"reloading",
			"currentPage"
		]),
	},
	methods: {},
};
